import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import arrowLeft from '../../assets/arrowLeft.svg';
import closeIcon from '../../assets/closeIcon.svg';
import helpIcon from '../../assets/helpIcon.svg';
import Button from '../../components/button/Button';
import { BatteryIcon } from '../../components/BatteryIcon/BatteryIcon';
import ToastChargerUnavailable from '../../components/chargerStationCardList/ToastChargerUnavailable/ToastChargerUnavailable';
import RechargePowerContent from '../../components/rechargePowerHeaderContent/RechargePowerHeaderContent';
import RechargePowerInfo from '../../components/rechargePowerInfo/RechargePowerInfo';
import Timer from '../../components/timer/Timer';
import ToastHelp from '../../components/toastHelp/ToastHelp';
import ToastStopCharging from '../../components/ToastStopCharging/ToastStopCharging';
import ToastCancelCharging from '../../components/ToastCancelCharging/ToastCancelCharging';
import ToastTimeExpired from '../../components/toastTimeExpired/ToastTimeExpired';
import { ConnectorStatus } from '../../constants/ConnectorStatus';
import { useBrandContext } from '../../context/BrandContext';
import {
  getCurrentPriceProfilePeriod,
  postStartCharging,
  postStopCharging
} from '../../services/chargerStationService';
import { getConnectorStatus } from '../../services/rechargeService';
import { getFormatedTimeMiliSeconds } from '../../utils/format';
import { useSocketContext } from '../../websocket/websocketProvider';
import './RechargeInfo.css';
import Modal from '../../components/modal/Modal';
import pinIcon from '../../assets/geo-alt-fill.svg';
import imageRoaming from '../../assets/world_roaming_charger_icon.svg';
import { getChargerSiteById } from '../../services/chargerSitesServices';
import { useCouponStore } from '../../hooks/useCouponStore';
import { cuponErrorMsgMap } from '../coupons/Coupons';

interface Props {
  CostChargeInfo?: any;
}

const errorDictionary = {
  ...cuponErrorMsgMap
};

const RechargeInfo: React.FC<Props> = ({ CostChargeInfo }) => {
  //const [chargerCurrencyPrice, setChargerCurrencyPrice] = useState<any>([]);
  const [errorStopCharging, setErrorStopCharging] = useState('');
  const [errorCancelCharging, setErrorCancelCharging] = useState('');

  const [modalOpen, setIsModalOpen] = useState(false);
  const [modalCancelOpen, setModalCancelOpen] = useState(false);
  const [isModalTimeExpiredOpen, setIsModalTimeExpiredOpen] = useState(false);
  const [openModalChargerUnavailable, setOpenModalChargerUnavailable] =
    useState(false);
  const [showHelpToast, setShowHelpToast] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState(false);
  const [startTimer, setStartTimer] = useState<boolean>(false);
  const [startTransaction, setStartTransaction] = useState(false);
  //const [isStopTransaction, setIsStopTransaction] = useState(false);
  const [stopTransaction, setStopTransaction] = useState<any>();
  const [transactionId, setTransactionId] = useState<any>('');
  const [priceProfile, setPriceProfile] = useState<any>();
  const [conectorStatus, setConectorStatus] = useState<any>({});
  //const location = useLocation();
  const [transactionStartTime, setTransactionStartTime] = useState<
    Date | undefined
  >();

  const [titleErrorModal, setTitleErrorModal] = useState<string>('');
  const [textErrorModal, setTextErrorModal] = useState<string>('');

  const brandContext = useBrandContext();
  const navigate = useNavigate();
  const value = useSocketContext();
  const { chargePointId, connectorId } = useParams();
  const [totalMiliSeconds, setTotalMiliSeconds] = useState(0);
  const [site, setSite] = useState({
    nameSite: '',
    addressSite: '',
    isOcpi: false
  });

  const { setCouponData, selectedCoupon, setSelectedCoupon } = useCouponStore();

  useEffect(() => {
    //console.log("stopTransaction:",stopTransaction);
    if (stopTransaction) {
      navigate(
        `/${brandContext.brandName}/extract/recharge/${stopTransaction.transactionId}`
      );
    }
  }, [stopTransaction]);

  useEffect(() => {
    if (!chargePointId || !connectorId) return;

    const getConnectorInfos = async (
      chargePointId: string,
      connectorId: string
    ) => {
      try {
        const response = await getConnectorStatus(
          chargePointId!,
          Number(connectorId)
        );
        const infoChargeInfos = response.find(
          (item: any) =>
            item.chargerId === chargePointId &&
            item.connectorId === Number(connectorId)
        );
        if (infoChargeInfos) {
          //console.log("getConnectorInfos", infoChargeInfos.startPriceProfilePeriod);

          if (infoChargeInfos.transaction) {
            //console.log("infoChargeInfos.transaction",infoChargeInfos.transaction.startPriceProfilePeriod);
            setPriceProfile(
              infoChargeInfos.transaction.startPriceProfilePeriod
            );
          } else if (CostChargeInfo) {
            //console.log("CostChargeInfo",CostChargeInfo);
            setPriceProfile(CostChargeInfo);
          } else {
            try {
              const data = await getCurrentPriceProfilePeriod(chargePointId);
              //console.log("getCurrentPriceProfilePeriod",data);
              setPriceProfile(data);
            } catch (e) {
              console.log('ERRO GET SALDO API: ', e);
            }
          }

          setConectorStatus(infoChargeInfos);

          if (infoChargeInfos?.transaction?.transactionId) {
            setTransactionId(infoChargeInfos?.transaction?.transactionId);
            setTransactionStartTime(infoChargeInfos?.transaction?.startTime);
            getTimeMiliSeconds(infoChargeInfos?.transaction?.startTime);
            setStartTimer(false);
            setStartTransaction(true);
          } else {
            setStartTimer(true);
          }
        }
      } catch (error: any) {
        console.error('Erro ao consultar informações recarga', error);
      }
    };

    getConnectorInfos(chargePointId, connectorId);
  }, [chargePointId, connectorId]);

  useEffect(() => {
    if (!value.messages || !chargePointId || !connectorId) return;

    let jsonArray = value.messages?.map((jsonString) => JSON.parse(jsonString));

    if (jsonArray.length > 0 && chargePointId && connectorId) {
      jsonArray.forEach((json) => {
        if (
          json.eventType === 'StartTransactionIntegrationEvent' &&
          (json?.transaction?.chargePointId as string) == chargePointId &&
          (json?.transaction?.connectorId as string) == connectorId
        ) {
          setTransactionId(json?.transaction?.transactionId);
          setStartTimer(false);
          setTransactionStartTime(json?.transaction?.startTime);
          setStartTransaction(true);
        } else if (
          json.eventType === 'ErrorStartTransactionIntegrationEvent' &&
          (json?.transaction?.chargePointId as string) == chargePointId &&
          (json?.transaction?.connectorId as string) == connectorId
        ) {
          setTitleErrorModal('Erro ao iniciar a recarga.');
          setTextErrorModal(errorDictionary[json?.errorCode]);
          setShowErrorModal(true);
        } else if (
          json.eventType === 'StopTransactionIntegrationEvent' &&
          json?.transaction?.transactionId == transactionId
        ) {
          //console.log("StopTransactionIntegrationEvent",json);
          setStopTransaction(json?.transaction);
          //setIsStopTransaction(true);
          setStartTransaction(false);
        }

        if (
          json.eventType === 'UpdateConnectorStatusIntegrationEvent' &&
          json?.connectorStatus?.transaction?.transactionId == transactionId
        ) {
          setConectorStatus(json?.connectorStatus);
        }
      });
    }
  }, [value.messages, chargePointId, connectorId, transactionId]);

  useEffect(() => {
    if (!transactionStartTime) return;

    const interval = setInterval(() => {
      getTimeMiliSeconds(transactionStartTime);
    }, 1000);
  }, [transactionStartTime]);

  useEffect(() => {
    return () => {};
  }, []);

  const stopRecharge = async () => {
    setIsLoading(true);
    try {
      const response = await postStopCharging(
        conectorStatus?.chargerId,
        conectorStatus?.connectorId,
        transactionId!
      );
      setIsLoading(false);
      if (response.status === 'Accepted') {
        setIsModalOpen(false);
        setCouponData({});
        setSelectedCoupon('');
      } else {
        setErrorStopCharging('Solicitação de finalização rejeitada.');
      }
    } catch (error: any) {
      console.error('Erro ao parar recarga', error);
      setIsLoading(false);
      if (error?.message === 'Network Error') {
        setErrorStopCharging(
          'Sua conexão está instável. Por favor, tente mais tarde.'
        );
      } else {
        setErrorStopCharging('Falha no servidor. Por favor tente novamente.');
      }
    }
  };

  function navigateToHome() {
    setCouponData({});
    setSelectedCoupon('');
    navigate(`/${brandContext.brandName}`);
    //localStorage.removeItem("formattedOrderItem");
  }

  const navigateToChargers = () => {
    setIsModalTimeExpiredOpen(false);
    setOpenModalChargerUnavailable(false);
    navigate(`/${brandContext.brandName}/charger/${conectorStatus.siteId}`);
    //localStorage.removeItem("formattedOrderItem");
  };

  const changeTextButton = () => {
    if (!stopTransaction) {
      if (
        (conectorStatus?.status?.toUpperCase() ===
          ConnectorStatus.CHARGING.toUpperCase() ||
          conectorStatus?.status?.toUpperCase() ===
            ConnectorStatus.SUSPENDEDEV.toUpperCase() ||
          conectorStatus?.status?.toUpperCase() ===
            ConnectorStatus.SUSPENDEDEVSE.toUpperCase()) &&
        startTransaction
      ) {
        return 'Finalizar recarga';
      } else if (
        conectorStatus?.status
          ?.toUpperCase()
          .includes(ConnectorStatus.AVAILABLE.toUpperCase()) ||
        conectorStatus?.status
          ?.toUpperCase()
          .includes(ConnectorStatus.PREPARING.toUpperCase())
      ) {
        return 'Cancelar recarga';
      }
    }
  };

  const handleStartCharging = async () => {
    setIsLoading(true);
    try {
      const response = await postStartCharging(
        conectorStatus?.chargerId,
        conectorStatus?.connectorId,
        null,
        selectedCoupon && selectedCoupon.trim() !== '' ? selectedCoupon : null
      );
      setIsLoading(false);
      if (response.status === 'Accepted') {
        setIsModalTimeExpiredOpen(false);
        setOpenModalChargerUnavailable(false);

        if (!conectorStatus?.transaction?.transactionId) {
          setStartTimer(true);
        }
      } else if (response.status === 'TimedOut') {
        setOpenModalChargerUnavailable(true);
        setIsModalTimeExpiredOpen(false);
      } else {
        setOpenModalChargerUnavailable(true);
        setIsModalTimeExpiredOpen(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error('Erro ao iniciar recarga', error);
    }
  };

  const handleButtonInfoCharge = () => {
    if (
      conectorStatus?.status === 'charging' ||
      conectorStatus?.transaction?.transactionId
    ) {
      setIsModalOpen((openModal) => !openModal);
    } else if (
      (conectorStatus?.status === 'available' ||
        conectorStatus?.status === 'preparing') &&
      !conectorStatus?.transaction?.transactionId
    ) {
      setModalCancelOpen((modalCancelOpen) => !modalCancelOpen);
    }
  };

  const getTimeMiliSeconds = (initialDate: Date) => {
    if (initialDate) {
      setTotalMiliSeconds(
        new Date().getTime() - new Date(initialDate).getTime()
      );
    } else setTotalMiliSeconds(0);
  };

  const getStopTime = (transactionInfo: any) => {
    const initialDate: Date = new Date(transactionInfo?.startTime);
    const finalDate: Date = new Date(transactionInfo?.stopTime);
    return getFormatedTimeMiliSeconds(
      finalDate.getTime() - initialDate.getTime()
    );
  };

  const showMenssageBasedConectorStatus = () => {
    if (startTimer) {
      return 'Conecte o plug no seu veículo e aguarde.';
    } else if (stopTransaction) {
      return 'Recarga finalizada';
    } else if (
      conectorStatus?.status
        ?.toUpperCase()
        .includes(ConnectorStatus.SUSPENDEDEV.toUpperCase())
    ) {
      return 'Finalizando recarga';
    } else if (
      conectorStatus?.status
        ?.toUpperCase()
        .includes(ConnectorStatus.SUSPENDEDEVSE.toUpperCase())
    ) {
      return 'Pausado';
    } else if (
      conectorStatus?.status
        ?.toUpperCase()
        .includes(ConnectorStatus.CHARGING.toUpperCase())
    ) {
      return 'Carregando';
    } else if (
      conectorStatus?.status
        ?.toUpperCase()
        .includes(ConnectorStatus.FAULTED.toUpperCase())
    ) {
      return 'Falha';
    } else if (handleIsFinishing()) {
      return 'Desconecte o plug do seu veículo';
    } else {
      return null;
    }
  };

  const handleIsFinishing = () => {
    if (
      conectorStatus?.status
        ?.toUpperCase()
        .includes(ConnectorStatus.FINISH.toUpperCase())
    ) {
      return true;
    }
    return false;
  };

  const handleMeterKWH = () => {
    if (stopTransaction) {
      return stopTransaction?.meterTotal;
    } else if (conectorStatus?.meterKWH) {
      return conectorStatus?.meterKWH;
    } else {
      return 0;
    }
  };

  const handleChargeRateKW = () => {
    if (stopTransaction) {
      return stopTransaction?.chargeRateKW;
    } else if (conectorStatus?.chargeRateKW) {
      return conectorStatus?.chargeRateKW;
    } else {
      return 0;
    }
  };

  const handleCancelCoupon = () => {
    setCouponData({});
    setSelectedCoupon('');
    navigateToChargers();
  };

  useEffect(() => {
    if (conectorStatus.siteId) {
      const loadSiteData = async () => {
        const siteSite = await getChargerSiteById(conectorStatus.siteId);
        setSite({
          nameSite: siteSite.csName,
          addressSite: siteSite.csFormattedAddress,
          isOcpi: siteSite.isOcpi
        });
      };
      loadSiteData();
    }
  }, [conectorStatus.siteId]);

  return (
    <div
      style={
        modalOpen ||
        modalCancelOpen ||
        isModalTimeExpiredOpen ||
        openModalChargerUnavailable ||
        showHelpToast ||
        showErrorModal
          ? {
              height: '100vh',
              width: '100vw',
              overflow: 'hidden',
              position: 'fixed',
              top: 0,
              left: 0
            }
          : {}
      }
    >
      <div className="recharge-info-main-container">
        <div className="recharge-header-content">
          <div onClick={navigateToHome} className="arrow-left-icon-container">
            <img
              className="style-arrow-left-icon"
              alt="arrow-left-icon"
              src={arrowLeft}
            />
          </div>
          <img onClick={navigateToChargers} alt="close-icon" src={closeIcon} />
        </div>
        <RechargePowerContent
          isStopTransaction={stopTransaction}
          meterKWH={handleMeterKWH()}
          chargeRateKW={handleChargeRateKW()}
          connectorStatus={conectorStatus}
        />
        {showMenssageBasedConectorStatus() && (
          <p className="recharge-info-plug-msg">
            <span className="mb-2">{showMenssageBasedConectorStatus()}</span>
            {conectorStatus.cmcType.toLowerCase() === 'dc' &&
              conectorStatus.status.toLowerCase() === 'charging' &&
              conectorStatus.soC !== null &&
              conectorStatus.soC !== undefined && (
                <>
                  <BatteryIcon percentage={conectorStatus.soC} size={16} />
                  <span style={{ fontWeight: 500 }}>
                    {conectorStatus.soC !== null &&
                    conectorStatus.soC !== undefined
                      ? `${
                          conectorStatus.soC % 1 < 0.5
                            ? Math.floor(conectorStatus.soC)
                            : Math.ceil(conectorStatus.soC)
                        }%`
                      : null}
                  </span>
                </>
              )}
          </p>
        )}

        <div className="location-info">
          <span className="location-info__name">
            <img src={pinIcon} alt="" className="location-info__icon" />
            {site.nameSite}{' '}
            {site?.isOcpi && (
              <img
                className="world-roaming-icon"
                loading="lazy"
                alt="roaming-icon"
                src={imageRoaming}
              />
            )}
          </span>
          <span className="location-info__address">{site.addressSite}</span>
        </div>

        <div className="estimated-value-section-main-container">
          {stopTransaction ? (
            <RechargePowerInfo
              conectorStatus={stopTransaction}
              isStopTransaction={true}
              time={getStopTime(stopTransaction)}
              //CostChargeInfo={priceProfile}
              initialRechargerInfo={conectorStatus}
              priceProfile={priceProfile}
            />
          ) : (
            <RechargePowerInfo
              conectorStatus={conectorStatus}
              time={
                !startTimer ? (
                  getFormatedTimeMiliSeconds(totalMiliSeconds)
                ) : (
                  <Timer
                    startTimer={startTimer}
                    setIsTimeExpired={setIsModalTimeExpiredOpen}
                    setStartTimer={setStartTimer}
                    milliSecondsTimeduration={
                      (conectorStatus.cmcType.toLowerCase() === 'dc'
                        ? 90
                        : 60) * 1000
                    }
                  />
                )
              }
              //CostChargeInfo={priceProfile}
              initialRechargerInfo={conectorStatus}
              priceProfile={priceProfile}
              isStopTransaction={false}
            />
          )}
          {!(stopTransaction || handleIsFinishing()) &&
            changeTextButton() !== undefined && (
              <Button
                style={{
                  backgroundColor: 'transparent',
                  color: '#00FFA3',
                  border: '1px solid #00FFA3'
                }}
                type="button"
                children={changeTextButton()}
                onClick={handleButtonInfoCharge}
                spinnerSecondary={true}
                loading={isLoading}
              />
            )}
          <div className="charger_help-button">
            <button
              className="help-button"
              onClick={() => setShowHelpToast(true)}
            >
              <span>{'Ajuda'}</span>
              <img alt="help-icon" src={helpIcon} />
            </button>
          </div>
        </div>
      </div>
      <ToastHelp
        isModalOpen={showHelpToast}
        allowButtonClosed={true}
        setShowHelpToast={setShowHelpToast}
      />
      <ToastStopCharging
        setErrorStopCharging={setErrorStopCharging}
        errorStopCharging={errorStopCharging}
        setIsModalOpen={setIsModalOpen}
        isLoading={isLoading}
        allowButtonClosed={true}
        handleStopCharging={stopRecharge}
        isModalOpen={modalOpen}
      />
      <ToastCancelCharging
        setErrorCancelCharging={setErrorCancelCharging}
        errorStopCharging={errorCancelCharging}
        setIsModalOpen={setModalCancelOpen}
        isLoading={isLoading}
        allowButtonClosed={true}
        handleCancelCharging={() => {
          handleCancelCoupon();
        }}
        isModalOpen={modalCancelOpen}
      />
      <ToastTimeExpired
        handleClose={navigateToChargers}
        isLoading={isLoading}
        allowButtonClosed={true}
        handleStartCharging={handleStartCharging}
        isModalOpen={isModalTimeExpiredOpen}
      />
      <ToastChargerUnavailable
        onClose={navigateToChargers}
        isLoading={isLoading}
        allowButtonClosed={true}
        handleStartCharging={handleStartCharging}
        isModalOpen={openModalChargerUnavailable}
        setIsModalOpen={setOpenModalChargerUnavailable}
      />
      <Modal
        allowButtonClosed={false}
        isOpen={showErrorModal}
        onClose={() => {
          handleCancelCoupon();
        }}
        title={titleErrorModal}
        styleEnterButton={{
          backgroundColor: 'rgb(173, 173, 173)',
          border: 'none'
        }}
        textEnterButton="Fechar"
        handleEnterButton={() => {
          handleCancelCoupon();
        }}
        isLoadingEnterButton={false}
      >
        <p>{textErrorModal}</p>
      </Modal>
    </div>
  );
};

export default RechargeInfo;
